export default __webpack_public_path__ + "static/media/tokit4.cb84fd41.png";